
export default {
  page_title: 'Configuración Idioma de empresa',
  header_lang: 'Lenguaje',
  header_code: 'Código'
}
